import {Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name: 'TxnDeliveryStatusFilter'
})

export class TxnDeliveryStatusFilter implements PipeTransform {
    transform(items: any, filter: any): any {
        if (items==null || items ==undefined) {
            return null;
        }
        return items.filter(item=>{
            return item.order_status === filter;
        })
    }
}


// WEBPACK FOOTER //
// ./src/filters/txndeliverystatus.pipe.ts